import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/settings/')({
  staticData: { breadcrumb: 'Settings', breadcrumbKey: 'K_PAGE_TITLE_SETTINGS' },
});
